import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { RolComponent } from '../rol/rol.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RolRoutingModule } from './rol-routing.module';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}

@NgModule({
    declarations: [RolComponent],
    imports: [
      SharedModule,
      CommonModule,
      RolRoutingModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        },
        isolate: true
      })
    ]
  })
  export class RolModule { }
